import { IAccount } from '@account-users';
import { Permission } from '@account-users/account/models/Permission';
import { UserRolesAndPermissionsService } from '@account-users/user/services/user-roles-and-permissions.service';
import { hasPermission } from '@account-users/user/state';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { TemplateActions } from '../../actions';
import {
  CopyTemplateModalComponent,
  RebBootstrapTemplatesModalComponent,
} from '../../components';
import { CopyTemplate } from '../../models';
import { State, getAccountsSortedByName, getTemplates } from '../../reducers';

@Component({
  selector: 'app-email-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss'],
})
export class TemplateComponent implements OnInit, OnDestroy {
  hasCanWriteEmailTemplate$ = this.store.pipe(
    select(hasPermission(Permission.CanWriteEmailTemplate)),
  );
  hasCanWriteEmailBootstrap$ = this.store.pipe(
    select(hasPermission(Permission.CanWriteEmailBootstrap)),
  );

  public hasWawRole$: Observable<boolean>;

  modalRef: NgbModalRef;
  accounts: IAccount[] = [];

  private destroy$ = new Subject();

  constructor(
    private readonly modalService: NgbModal,
    private readonly store: Store<State>,
    private readonly userRolesService: UserRolesAndPermissionsService,
  ) {}

  ngOnInit() {
    this.store
      .pipe(select(getAccountsSortedByName), takeUntil(this.destroy$))
      .subscribe((accounts) => (this.accounts = accounts));

    this.store
      .pipe(
        select(getTemplates),
        takeUntil(this.destroy$),
        filter(() => !!this.modalRef),
      )
      .subscribe(
        (templates) => (this.modalRef.componentInstance.templates = templates),
      );

    this.hasWawRole$ = this.userRolesService.hasWawRole$;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  openCopyTemplateModal() {
    this.modalRef = this.modalService.open(CopyTemplateModalComponent, {
      backdrop: 'static',
      keyboard: false,
    });

    const { componentInstance } = this.modalRef;

    componentInstance.accounts = this.accounts;
    componentInstance.fetchTemplates.subscribe((accountId: string) =>
      this.store.dispatch(TemplateActions.fetchRequest({ accountId })),
    );
    componentInstance.copyTemplate.subscribe((copyTemplate: CopyTemplate) => {
      this.modalRef.close();
      this.store.dispatch(TemplateActions.copyRequest(copyTemplate));
    });
  }

  openReBootstrapTemplatesModal(allAccounts = false) {
    this.modalRef = this.modalService.open(
      RebBootstrapTemplatesModalComponent,
      { backdrop: 'static', keyboard: false },
    );

    const { componentInstance } = this.modalRef;
    componentInstance.accounts = this.accounts;
    componentInstance.allAccounts = allAccounts;

    componentInstance.reBootstrap.subscribe((accountId: string) => {
      this.modalRef.close();
      this.store.dispatch(TemplateActions.reBootstrapRequest({ accountId }));
    });
  }
}
